import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import LeaveAllocation from '../components/LeaveAllocation'
import ClaimAllocation from '../components/ClaimAllocation'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { getAllocationData } from 'services/api/modules/staff-management/staffManagementDashboard'

const AllocationTab = () => {
  const params = useParams()
  const [savedAllocation, setSavedAllocation] = useState(null)

  const { isLoading, isFetching, error, data: allocation } = useQuery(
    ['employeeAllocationData', params.id],
    async () => {
      const res = await getAllocationData(params.id)
      // backend shape: { success, message, data: { leave: {...}, claim: [...] } }
      return res?.data?.data ?? null
    },
    {
      enabled: !!params.id,
      keepPreviousData: true,
      refetchOnMount: 'always',
      staleTime: 0,
    }
  )

  useEffect(() => {
    if (allocation) {
      setSavedAllocation(allocation)
    }
  }, [allocation])

  if (isLoading) return <Box p={2}>Loading allocation...</Box>
  if (error) return <Box p={2}>Failed to load allocation.</Box>

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2 }}>
      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <LeaveAllocation
          data={savedAllocation}
          staffId={params.id}
          isFetching={isFetching}
          onAllocationSaved={setSavedAllocation}
        />
      </Box>

      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <ClaimAllocation data={savedAllocation} isFetching={isFetching} />
      </Box>
    </Box>
  )
}

export default AllocationTab
